export default "<div *ngIf=\"viewInfo\" style=\"text-align: center;\">\n    <img mat-card-image [src]=\"viewInfo\" style=\"width: 70%;\">\n</div>"